import { legacy_createStore as createStore } from "redux";
import portal from "./portal";

const store: any = createStore(portal);
export default store;